import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';

import { InfoMessageComponent } from './info-message.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    
    MatIconModule
  ],
  exports: [
    InfoMessageComponent
  ],
  providers: [
  ],
  declarations: [
    InfoMessageComponent
  ]
})
export class InfoMessageModule { }
